import React from 'react';
import {Box, Grid} from '@material-ui/core';
import PropTypes, {InferProps} from 'prop-types';

import {EfeCommonField} from 'components';
import {Field} from 'commons/models';
import {FieldShape} from 'commons/shapes';

EfeCommonRow.propTypes = {
    rows: PropTypes.shape({
        row: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired)
            .isRequired,
        index: PropTypes.number.isRequired,
    }).isRequired,
    setFieldValue: PropTypes.func.isRequired,
    values: PropTypes.any.isRequired,
    errors: PropTypes.any.isRequired,
};

function EfeCommonRow(props: InferProps<typeof EfeCommonRow.propTypes>) {
    const {rows, setFieldValue, values, errors} = props;
    /* eslint-disable react/jsx-handler-names */
    return (
        <Grid item xs={12}>
            <Box display='flex' flexDirection='row' justifyContent='center'>
                {rows &&
                    rows.row.length > 0 &&
                    rows.row.map((item: Field, key: number) => {
                        return (
                            <EfeCommonField
                                key={`common-field-${key}`}
                                field={item}
                                index={key}
                                setFieldValue={setFieldValue}
                                values={values}
                                errors={errors}
                            />
                        );
                    })}
            </Box>
        </Grid>
    );
}

export default EfeCommonRow;
